import { addSymbol } from 'virtual:svg-sprite-runtime'
const id = "icon_play"
const viewBox = "0 0 46 52"
addSymbol(id, "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 6.76779C2 3.14379 5.6793 0.848487 8.6822 2.59919L41.6709 21.8314C44.7764 23.6418 44.7764 28.3582 41.6709 30.1686L8.6823 49.4008C5.6793 51.1515 2 48.8562 2 45.2322V6.76779Z\" fill=\"currentColor\"/>", viewBox)
export default { id, viewBox }